import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "Redux/Actions/actionTypes";
import GetLoanIncome from "Communication/ApiClasses/GetLoanIncomeRequest";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";
import STRINGS from "Constants/Strings";

// worker
function* handleGetLoanIncome(action) {
  yield put(doLoadingStart(STRINGS.INCOME.API_KEYS.LOAN_GET_INCOME));
  const getLoanIncome = new GetLoanIncome(
    action.data.applicantId,
    action.data.finAnalysisId,
    action.data.financialId
  );
  try {
    const result = yield call(getLoanIncome.getData);
    yield put({
      type: actionTypes.LOAN_GET_INCOME_SUCCESS,
      response: result,
    });
    yield call(action.callback, result);
  } catch (e) {
    yield put({
      type: actionTypes.LOAN_GET_INCOME_ERROR,
      error: e.message,
    });
  } finally {
    yield put(doLoadingFinish(STRINGS.INCOME.API_KEYS.LOAN_GET_INCOME));
  }
}

// watcher
function* getLoanIncomeWatcherSaga() {
  yield takeLatest(actionTypes.LOAN_GET_INCOME, handleGetLoanIncome);
}

export default getLoanIncomeWatcherSaga;
